import { defineStore } from 'pinia';

export type OnceKey = string;

export interface IOnceState {
  seen: Record<OnceKey, boolean>;
}

export const useOnceStore = defineStore('once', {
  state: (): IOnceState => ({
    seen: {},
  }),
  getters: {
    hasSeen: (state) => (key: OnceKey) => !!state.seen[key],
  },
  actions: {
    markSeen(key: OnceKey): void {
      this.seen[key] = true;
    },
    clearKey(key: OnceKey): void {
      delete this.seen[key];
    },
  },
  persist: true,
});
